// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__quosD","itemTitle":"ClientEmergencyInfo_itemTitle__2CLTQ","itemText":"ClientEmergencyInfo_itemText__3pVyx"};